/**
 * Whether this is an Intel Mac, known before the first render: Rust stamps
 * `<html data-denker-intel="true">` there, and only there, before the bundle
 * loads (`intel_arch_stamp_script` in lib.rs).
 */
export function isIntelMac(): boolean {
  return (
    typeof document !== "undefined" &&
    document.documentElement.dataset.denkerIntel === "true"
  );
}
